/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component } from "react";
import Grid from "@mui/material/Grid";
import Input from "../../../component/inputpm";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import classes from "./bucket.module.css";
import tab from "./createPackage.module.css";
import Button from "../../../component/button";
import Icon from "@mui/material/Icon";
// import MUIRichTextEditor from "mui-rte";
// import { createTheme, MuiThemeProvider } from '@mui/material/styles'
import { connect } from "react-redux";
import actionTypes from "../../../store/actions";
import constants from "../../../helper/constants";
import imageClass from "../packagedSolutionList/packagedSolutionList.module.css";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import Loader from "../../../component/loader";
import placeholderImage from "../../../asset/images/image_placeholder.png";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import BusApiCall from "../../../helper/axios";
import { withTranslation } from "react-i18next";
import currencyFormatter from "../../../helper/currencyFormatter";
import { ListItemText, List, ListItem, ListItemButton } from "@mui/material";
import CustomAttributes from "../component/customAttributes";
import Box from "@mui/material/Box";
// import TextEditor from "../../../component/richTextEditor";
import TiptapEditor from "../../../component/richTextEditor/TiptapEditor";
import UriEncode from "../../../component/uriEncode/uriEncode";
import Drawer from "@mui/material/Drawer";
import { ChevronLeft } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { Card } from "@mui/material";
import Split from 'react-split';
import { styled, alpha } from "@mui/material/styles";

const StyledNavListItem = styled(ListItem, {
  shouldForwardProp: (prop) => prop !== 'isSelected' && prop !== 'themeColor',
})(({ theme, isSelected, themeColor }) => ({
  borderRadius: isSelected ? '0px 6px 6px 0px' : theme.shape.borderRadius,
  borderLeft: `2px solid ${isSelected ? themeColor : 'transparent'}`,
  fontWeight: isSelected ? 'bold' : 'normal',
  color: isSelected ? themeColor : 'inherit',
  transition: 'background-color 0.2s ease',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: alpha(themeColor, 0.12),
    color: themeColor,
  },
}));

// const styles = (theme) => ({
//     listItem: {
//         borderRadius: 6,
//         transition: 'background-color 0.2s ease',
//         '&:hover': {
//           backgroundColor: (props) => alpha(props.themeColor, 0.12),
//           color: (props) => props.themeColor,
//         },
//       },
//       selected: {
//         borderRadius: '0px 6px 6px 0px',
//         borderLeft: (props) => `2px solid ${props.themeColor}`,
//         fontWeight: 'bold',
//         color: (props) => props.themeColor,
//         '&:hover': {
//           backgroundColor: (props) => alpha(props.themeColor, 0.12)
//         },
//       },
// });

class BasicDetails extends Component {
  state = {
    bom: false,
    productName: "",
    localisedName: [],
    featureCode: "",
    startingPrice: "",
    localisedDesc: [],
    productDescription: "",
    productOverview:
      '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
    productTechSpecs:
      '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
    productWhatsIncluded:
      '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
    localisedOverview: [],
    localisedTechSpecs: [],
    localisedWhatsIncluded: [],
    productMainImage: "",
    productMainImageSource: "",
    productAdditionalImage1: "",
    productAdditionalImage2: "",
    productAdditionalImage3: "",
    productAdditionalImage4: "",
    productAdditionalImage1Src: "",
    productAdditionalImage2Src: "",
    productAdditionalImage3Src: "",
    productAdditionalImage4Src: "",
    termsText: "",
    termsUrl: "",
    //partnerId: null,
    categoryId: "",
    tabValue: 0,
    open: false,
    disableButton: false,
    terms: [],
    categoryList: [],
    loading: true,
    overrideStartingPrice: false,
    termCondToEdit: null,
    showCategory: false,

    fieldsWithError: [],
    originalStartingPrice: 0,
    providerId: "",
    customAttributes: [],
    customAttributesList: [],
    tempSelectedAttribute: {
      attrName: ''
    },
    // providerId: '',
    language: "en_US",
    languageOverview: "en_US",
    languageTechSpecs: "en_US",
    languageWhatsIncluded: "en_US",
    // productOverviewState: EditorState.createEmpty(),
    // productTechSpecsState: EditorState.createEmpty(),
    // productWhatsIncludedState: EditorState.createEmpty(),
    originalProviderId: "",
    originalProviderName: "",
    originalProviderType: "",
    activeTab: 0,
  };

  constructor(props) {
    super(props);
    this.editorRef = React.createRef();
  }

  componentDidMount() {
    this.props.onRef(this);
    this.props.setCompDidMount();
    let bdCopy = { ...this.props.basicDetail };
    const showBucketsOnLeft = localStorage.getItem("showBucketsOnLeft");
    if (this.props.basicDetail.productName) {
      this.props.onChangePackagedSolutionName(
        this.props.basicDetail.productName,
      );
    }
    this.setState({
      originalStartingPrice: bdCopy.originalStartingPrice,
      showBucketsOnLeft: showBucketsOnLeft === "false" ? false : true,
    });

    if (this.props.packageMode === "edit") {
      let mainImage = this.props.images;
      if (mainImage) {
        bdCopy.productMainImage = mainImage[0];
      }
    }
    this.setState({ ...bdCopy }, () => {
      try {
        let productOverviewState,
          productTechSpecsState,
          productWhatsIncludedState;
        // if (this.state.productOverview) {
        //   const initialProductOverview = JSON.parse(this.state.productOverview);
        //   productOverviewState = EditorState.createWithContent(
        //     convertFromRaw(initialProductOverview),
        //   );
        // } else {
        //   productOverviewState = EditorState.createEmpty();
        // }
        // if (this.state.productTechSpecs) {
        //   const initialTechSpecs = JSON.parse(this.state.productTechSpecs);
        //   productTechSpecsState = EditorState.createWithContent(
        //     convertFromRaw(initialTechSpecs),
        //   );
        // } else {
        //   productTechSpecsState = EditorState.createEmpty();
        // }
        // if (this.state.productWhatsIncluded) {
        //   const initialWhatsIncluded = JSON.parse(
        //     this.state.productWhatsIncluded,
        //   );
        //   productWhatsIncludedState = EditorState.createWithContent(
        //     convertFromRaw(initialWhatsIncluded),
        //   );
        // } else {
        //   productWhatsIncludedState = EditorState.createEmpty();
        // }
        // this.setState({
        //   productOverviewState,
        //   productTechSpecsState,
        //   productWhatsIncludedState,
        // });
      } catch (error) {
        console.error("Error parsing editor content: ", error);

        // this.setState({
        //   productOverviewState: EditorState.createEmpty(),
        //   productTechSpecsState: EditorState.createEmpty(),
        //   productWhatsIncludedState: EditorState.createEmpty(),
        // });
      }
    });

    if (this.props.psTemplate === "QA") {
      this.setState({
        productMainImage: "generic-packaged-solution-image.jpeg",
        productMainImageSource:
          "data:image/jpeg;base64,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",
      });
    }
    BusApiCall(
      "GET",
      `${constants.busV4Url}/providers/${this.props.providerId}/menus`,
    )
      .then((res) => {
        this.setState({
          categoryList: res.data.menuCategories,
          //categoryList: res.data.menuFilteredByCategory,
          loading: false,
        });
        this.getCustomAttributes();
        if (this.props.packageMode === "edit") {
          this.setState({ categoryId: bdCopy.categoryId, showCategory: true });
        } else {
          this.setState({ showCategory: true });
        }
        let t = this.props.t;
        this.setState({
          /*
                categoryList: [
                    { categoryId: "ASSET_CAT", categoryName: t('ASSET') },
                    { categoryId: "BRD_CAT", categoryName: t('BROADBAND') },
                    { categoryId: "BUILD_MGMT", categoryName: t('BUILD_MGMT') },
                    { categoryId: "BAPPS_CAT", categoryName: t('BUSINESS_APPS') },
                    { categoryId: "CABLE_CAT", categoryName: t('CABLE') },
                    { categoryId: "CONN_HEALTH", categoryName: t('CONN_HEALTH') },
                    { categoryId: "CONN_CAT", categoryName: t('CONNECTIVITY') },
                    { categoryId: "FLEET_CAT", categoryName: t('FLEET') },
                    { categoryId: "HEALTHMONITORING", categoryName: t('HEALTH_MONITORING') },
                    { categoryId: "MOB_CAT", categoryName: t('MOBILE') },
                    { categoryId: "MON_CAT", categoryName: t('MONITORING') },
                    { categoryId: "SEC_CAT", categoryName: t('SECURITY_&_SAFETY') },
                    { categoryId: "SMART_CAT", categoryName: t('SMART_FACTORY') },
                    { categoryId: "SPM_CAT", categoryName: t('SPACE_MANAGEMENT') },
                ]
                */
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
        this.getCustomAttributes();
      });
  }

  getCustomAttributes = () => {
    BusApiCall("GET", `${constants.busV4Url}/catalog/allComponentTypes`)
      .then((res) => {
        var data = res.data;
        var cData = JSON.parse(data.jsonResponse);
        if (cData && cData.unMappedTypes.length > 0) {
          for (var i = 0; i < cData.unMappedTypes.length; i++) {
            if (cData.unMappedTypes[i].id == "PROD_COMP_ALL") {
              var count = cData.unMappedTypes[i].customAttributes
                ? cData.unMappedTypes[i].customAttributes.length
                : 0;
              var customAttributesList = JSON.parse(
                JSON.stringify(
                  cData.unMappedTypes[i].customAttributes
                    ? cData.unMappedTypes[i].customAttributes
                    : [],
                ),
              );
              var customAttributes = [];
              if (this.state.customAttributes) {
                customAttributes = this.state.customAttributes;
              }
              if (customAttributesList && customAttributesList.length > 0) {
                if (this.props.packageMode === "edit") {
                  for (var i = customAttributesList.length - 1; i >= 0; i--) {
                    var index = customAttributes.findIndex(
                      (x) => x.attrName === customAttributesList[i].attrName,
                    );
                    if (index > -1) {
                      customAttributes[index].valueType =
                        customAttributesList[i].valueType;
                      customAttributes[index].options = customAttributesList[i]
                        .options
                        ? customAttributesList[i].options
                        : [];
                      customAttributes[index].required =
                        customAttributesList[i].required;
                      if (customAttributes[index].valueType === "collection") {
                        if (
                          this.isJsonString(customAttributes[index].attrValue)
                        ) {
                          var tempValues = JSON.parse(
                            customAttributes[index].attrValue,
                          );
                          customAttributes[index].attrValue = "";
                          for (var v = 0; v < tempValues.length; v++) {
                            customAttributes[index].attrValue =
                              tempValues[v].id;
                          }
                        }
                      } else if (
                        customAttributes[index].valueType === "boolean"
                      ) {
                        if (customAttributes[index].attrValue) {
                          if (
                            typeof customAttributes[index].attrValue ===
                            "string"
                          ) {
                            if (customAttributes[index].attrValue === "true") {
                              customAttributes[index].attrValue = true;
                            } else {
                              customAttributes[index].attrValue = false;
                            }
                          } else {
                            customAttributes[index].attrValue = true;
                          }
                        } else {
                          customAttributes[index].attrValue = false;
                        }
                      }
                      customAttributesList.splice(i, 1);
                    } else if (customAttributesList[i].required) {
                      var tempAttr = {
                        attrName: customAttributesList[i].attrName,
                        required: customAttributesList[i].required,
                        valueType: customAttributesList[i].valueType,
                        options: customAttributesList[i].options,
                        create: true,
                      };
                      if (tempAttr.valueType === "boolean") {
                        tempAttr.attrValue = false;
                      } else if (tempAttr.valueType === "collection") {
                        tempAttr.attrValue = "";
                      } else {
                        tempAttr.attrValue = "";
                      }
                      customAttributes.push(tempAttr);
                      customAttributesList.splice(i, 1);
                    }
                    if (i === 0) {
                      this.setState({
                        customAttributesList: customAttributesList,
                        customAttributes,
                      });
                    }
                  }
                } else {
                  for (var i = customAttributesList.length - 1; i >= 0; i--) {
                    var index = customAttributes.findIndex(
                      (x) => x.attrName === customAttributesList[i].attrName,
                    );
                    if (index > -1) {
                      customAttributesList.splice(i, 1);
                    } else if (customAttributesList[i].required) {
                      var tempAttr = {
                        attrName: customAttributesList[i].attrName,
                        required: customAttributesList[i].required,
                        valueType: customAttributesList[i].valueType,
                        options: customAttributesList[i].options,
                      };
                      if (tempAttr.valueType === "boolean") {
                        tempAttr.attrValue = false;
                      } else if (tempAttr.valueType === "collection") {
                        tempAttr.attrValue = "";
                      } else {
                        tempAttr.attrValue = "";
                      }
                      customAttributes.push(tempAttr);
                      customAttributesList.splice(i, 1);
                    }
                    this.setState({
                      customAttributesList: customAttributesList,
                      customAttributes,
                    });
                  }
                }
              }
              break;
            }
          }
        }
      })
      .catch((err) => { });
  };

  isJsonString(str) {
    if (str.includes("[") && str.includes("{")) {
      return true;
    } else {
      return false;
    }
  }

  handleChange = (event, newValue) => {
    this.handleEditor();
    this.setState({ tabValue: newValue });
  };

  updateProductName = () => {
    setTimeout(() => {
      //this.props.changePackageName(this.state.productName)
    }, 100);
  };

  onChange = (e) => {
    this.props.blockNavigation();
    this.props.setCompDidMount();
    //this.props.blockNavigation();
    if (e.target.name === "startingPrice") {
      if (e.target.value.split(".")[1]) {
        if (e.target.value.split(".")[1].length <= 2) {
          if (e.target.value === "" || e.target.value >= 0) {
            this.setState({
              [e.target.name]: e.target.value,
            });
          }
        }
      } else {
        if (e.target.value === "" || e.target.value >= 0) {
          this.setState({
            [e.target.name]: e.target.value,
          });
        }
      }
    } else if (e.target.name === "featureCode") {
      if (e.target.value.length < 25) {
        this.setState({
          [e.target.name]: e.target.value,
        });
      } else {
        // this.props.setErrorMessage(this.props.t('MAX_24_CHARACTER_ERROR'), false)
        return;
      }
    } else if (e.target.name === "productDescription") {
      if (e.target.value.length < 250) {
        this.setState({
          [e.target.name]: e.target.value,
        });
      } else {
        this.props.setErrorMessage(
          this.props.t("MAX_255_CHARACTER_ERROR"),
          false,
        );
      }
    } else if (e.target.name === "productName") {
      if (e.target.value.length < 100) {
        this.setState({
          [e.target.name]: e.target.value,
        });
        this.props.onChangePackagedSolutionName(e.target.value);
      } else {
        this.props.setErrorMessage(
          this.props.t("MAX_100_CHARACTER_ERROR"),
          false,
        );
      }
    } else if (e.target.name === "termsText") {
      if (e.target.value.length < 255) {
        this.setState({
          [e.target.name]: e.target.value,
        });
      } else {
        this.props.setErrorMessage(
          this.props.t("MAX_255_CHARACTER_ERROR"),
          false,
        );
      }
    } else if (e.target.name === "termsUrl") {
      if (e.target.value.length < 2000) {
        this.setState({
          [e.target.name]: e.target.value,
        });
      } else {
        this.props.setErrorMessage(this.props.t("URL_TOO_LONG_ERROR"), false);
      }
    } else {
      this.setState({
        [e.target.name]: e.target.value,
      });
    }
    if (e.target.name === "productName") {
      this.updateProductName();
    }

    this.setInputTextBasedOnLocale(e.target.name, e.target.value);
  };

  onLanguageChange = (e) => {
    this.props.blockNavigation();
    if (this.state.tabValue == 0 && this.state.localisedName) {
      this.setState({
        language: e.target.value,
      });
      var index = this.state.localisedName.findIndex(
        (x) => x.locale === e.target.value,
      );
      if (index > -1) {
        this.setState({
          productName: this.state.localisedName[index].text,
        });
      } else {
        this.setState({ productName: "" });
      }
    }
    if (this.state.tabValue == 0 && this.state.localisedDesc) {
      this.setState({
        language: e.target.value,
      });
      var index = this.state.localisedDesc.findIndex(
        (x) => x.locale === e.target.value,
      );
      if (index > -1) {
        this.setState({
          productDescription: this.state.localisedDesc[index].text,
        });
      } else {
        this.setState({ productDescription: "" });
      }
    }
    if (this.state.tabValue == 2 && this.state.localisedOverview) {
      var lang = e.target.value;
      this.handleEditor();
      setTimeout(() => {
        this.setState(
          {
            languageOverview: lang,
          },
          () => {
            var index = this.state.localisedOverview.findIndex(
              (x) => x.locale === lang,
            );
            if (index > -1) {
              this.setState({
                productOverview: this.state.localisedOverview[index].text,
                // productOverviewState: EditorState.createWithContent(
                //   convertFromRaw(
                //     JSON.parse(this.state.localisedOverview[index].text),
                //   ),
                // ),
              });
            } else {
              this.setState({
                productOverview:
                  '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
                // productOverviewState: EditorState.createEmpty(),
              });
            }
          },
        );
      }, 500);
    }
    if (this.state.tabValue == 3 && this.state.localisedTechSpecs) {
      var lang = e.target.value;
      this.handleEditor();
      setTimeout(() => {
        this.setState(
          {
            languageTechSpecs: lang,
          },
          () => {
            var index = this.state.localisedTechSpecs.findIndex(
              (x) => x.locale === lang,
            );
            if (index > -1) {
              this.setState({
                productTechSpecs: this.state.localisedTechSpecs[index].text,
                // productTechSpecsState: EditorState.createWithContent(
                //   convertFromRaw(
                //     JSON.parse(this.state.localisedTechSpecs[index].text),
                //   ),
                // ),
              });
            } else {
              this.setState({
                productTechSpecs:
                  '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
                // productTechSpecsState: EditorState.createEmpty(),
              });
            }
          },
        );
      }, 500);
    }
    if (this.state.tabValue == 4 && this.state.localisedWhatsIncluded) {
      var lang = e.target.value;
      this.handleEditor();
      setTimeout(() => {
        this.setState(
          {
            languageWhatsIncluded: lang,
          },
          () => {
            var index = this.state.localisedWhatsIncluded.findIndex(
              (x) => x.locale === lang,
            );
            if (index > -1) {
              this.setState({
                productWhatsIncluded:
                  this.state.localisedWhatsIncluded[index].text,
                // productWhatsIncludedState: EditorState.createWithContent(
                //   convertFromRaw(
                //     JSON.parse(this.state.localisedWhatsIncluded[index].text),
                //   ),
                // ),
              });
            } else {
              this.setState({
                productWhatsIncluded:
                  '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
                // productWhatsIncludedState: EditorState.createEmpty(),
              });
            }
          },
        );
      }, 500);
    }
  };

  setInputTextBasedOnLocale = (name, value) => {
    let valueObj = {};
    let targetName = "";
    let langValue = "";
    if (name === "productName") {
      targetName = "localisedName";
      langValue = this.state.language;
    } else if (name === "productDescription") {
      targetName = "localisedDesc";
      langValue = this.state.language;
    } else if (name === "productOverview") {
      targetName = "localisedOverview";
      langValue = this.state.languageOverview;
    } else if (name === "productTechSpecs") {
      targetName = "localisedTechSpecs";
      langValue = this.state.languageTechSpecs;
    } else if (name === "productWhatsIncluded") {
      targetName = "localisedWhatsIncluded";
      langValue = this.state.languageWhatsIncluded;
    }
    if (this.state[targetName]) {
      const hasLocale = this.state[targetName].some((obj) => {
        if (obj.locale === langValue) {
          return true;
        }
      });
      if (!hasLocale) {
        valueObj = {
          locale: langValue,
          text: value,
        };
        if (langValue != "") {
          this.state[targetName].push(valueObj);
        }
      } else {
        var index = this.state[targetName].findIndex(
          (x) => x.locale === langValue,
        );
        this.state[targetName][index].text = value;
      }
    }
  };

  onImageChange = (e, srcImage) => {
    if (e.target.files.length > 0) {
      this.setState({
        disableButton: true,
      });
      // var fileName = e.target.files[0].name;
      var name = e.target.name;
      // let file = e.target.files[0];
      let format = e.target.files[0].name
        .substring(e.target.files[0].name.lastIndexOf(".") + 1)
        .toLowerCase();
      let itemType = e.target.files[0].type;
      let fileSize = e.target.files[0].size;
      if (format === "jpg" || format === "jpeg" || format === "png") {
        let selectedFile = e.target.files;
        let file = null;
        let fileName = "";
        if (selectedFile.length > 0) {
          this.props.blockNavigation();
          // Select the very first file from list
          let fileToLoad = selectedFile[0];
          fileName = fileToLoad.name;
          // FileReader function for read the file.
          let fileReader = new FileReader();
          // Onload of file read the file content
          fileReader.onload = (fileLoadedEvent) => {
            var tempFile = fileLoadedEvent.target.result;
            file = tempFile.split(",")[1];
            this.setState({
              [name]: fileName,
              [srcImage]: `data:image/${format};base64,${file}`,
              disableButton: false,
            });
          };
          // Convert data to base64
          fileReader.readAsDataURL(fileToLoad);
        }
      }
    }
  };

  setValue = (nextTablVal) => {
    this.setState({ tabValue: nextTablVal });
  };

  save = (data, name) => {
    this.setInputTextBasedOnLocale(name, data);
    this.setState({
      [name]: data,
    });
  };

  handleEditor = () => {
    if (this.editorRef.current) {
      this.editorRef.current.save();
    }
    if (this.state.tabValue != 2 && this.state.localisedOverview) {
      var index = this.state.localisedOverview.findIndex(
        (x) => x.locale === "en_US",
      );
      if (index > -1) {
        this.setState(
          {
            languageOverview: "en_US",
            productOverview: this.state.localisedOverview[index].text,
          },
          () => { },
        );
      }
    }
    if (this.state.tabValue != 3 && this.state.localisedTechSpecs) {
      var index = this.state.localisedTechSpecs.findIndex(
        (x) => x.locale === "en_US",
      );
      if (index > -1) {
        this.setState(
          {
            languageTechSpecs: "en_US",
            productTechSpecsState: this.state.localisedTechSpecs[index].text,
          },
          () => { },
        );
      }
    }
    if (this.state.tabValue != 4 && this.state.localisedWhatsIncluded) {
      var index = this.state.localisedWhatsIncluded.findIndex(
        (x) => x.locale === "en_US",
      );
      if (index > -1) {
        this.setState(
          {
            languageWhatsIncluded: "en_US",
            productWhatsIncludedState: this.state.localisedWhatsIncluded[index].text,
          },
          () => { },
        );
      }
    }

    if (this.state.tabValue == 2 && this.state.localisedOverview) {
      var index = this.state.localisedOverview.findIndex(
        (x) => x.locale === this.state.languageOverview,
      );
      if (index > -1) {
        this.setState(
          {
            productOverview: this.state.localisedOverview[index].text,
          },
          () => {
            this.setInputTextBasedOnLocale(
              "productOverview",
              this.state.productOverview,
            );
          },
        );
      }
    }
    if (this.state.tabValue == 3 && this.state.localisedTechSpecs) {
      var index = this.state.localisedTechSpecs.findIndex(
        (x) => x.locale === this.state.languageTechSpecs,
      );
      if (index > -1) {
        this.setState(
          {
            // productTechSpecs: this.state.localisedTechSpecs[index].text,
            productTechSpecsState: this.state.localisedTechSpecs[index].text,
          },
          () => {
            this.setInputTextBasedOnLocale(
              "productTechSpecs",
              this.state.productTechSpecsState,
            );
          },
        );
      }
    }
    if (this.state.tabValue == 4 && this.state.localisedWhatsIncluded) {
      var index = this.state.localisedWhatsIncluded.findIndex(
        (x) => x.locale === this.state.languageWhatsIncluded,
      );
      if (index > -1) {
        this.setState(
          {
            productWhatsIncludedState: this.state.localisedWhatsIncluded[index].text,
          },
          () => {
            this.setInputTextBasedOnLocale(
              "productWhatsIncluded",
              this.state.productWhatsIncludedState,
            );
          },
        );
      }
    }
  };

  handleClose = () => {
    this.setState({
      open: false,
    });
  };

  overrideStartingPrice = (e) => {
    this.props.blockNavigation();
    this.setState({
      [e.target.name]: e.target.checked,
    });
  };

  isBom = (e) => {
    this.setState({
      [e.target.name]: e.target.checked,
    });
  };

  addTermsCond = () => {
    let termCondArray = this.state.terms ? [...this.state.terms] : [];
    termCondArray.push({
      termsText: this.state.termsText,
      termsUrl: this.state.termsUrl,
    });
    this.setState({
      terms: termCondArray,
      termsText: "",
      termsUrl: "",
    });
  };

  forceNext = (tab) => {
    this.handleEditor();
    setTimeout(() => {
      var originalProvider = {};
      if (this.state.originalProviderId) {
        originalProvider = {
          originalProviderId: this.state.originalProviderId,
          originalProviderName: this.state.originalProviderName,
          originalProviderType: this.state.originalProviderType,
        };
      }
      this.props.getPackageBasicDetails(
        {
          bom: this.state.bom,
          productName: this.state.productName,
          categoryId: this.state.categoryId,
          localisedName: this.state.localisedName,
          localisedDesc: this.state.localisedDesc,
          localisedOverview: this.state.localisedOverview,
          localisedTechSpecs: this.state.localisedTechSpecs,
          localisedWhatsIncluded: this.state.localisedWhatsIncluded,
          featureCode: this.state.featureCode,
          productDescription: this.state.productDescription,
          startingPrice: this.state.startingPrice,
          originalStartingPrice: this.state.originalStartingPrice,
          // productOverview: JSON.stringify(
          //   convertToRaw(this.state.productOverviewState.getCurrentContent()),
          // ),
          // productTechSpecs: JSON.stringify(
          //   convertToRaw(this.state.productTechSpecsState.getCurrentContent()),
          // ),
          // productWhatsIncluded: JSON.stringify(
          //   convertToRaw(
          //     this.state.productWhatsIncludedState.getCurrentContent(),
          //   ),
          // ),
          productOverview: this.state.productOverview,
          productTechSpecs: this.state.productTechSpecs,
          productWhatsIncluded: this.state.productWhatsIncluded,
          productMainImage: this.state.productMainImage,
          productMainImageSource: this.state.productMainImageSource,
          productAdditionalImage1: this.state.productAdditionalImage1,
          productAdditionalImage2: this.state.productAdditionalImage2,
          productAdditionalImage3: this.state.productAdditionalImage3,
          productAdditionalImage4: this.state.productAdditionalImage4,
          productAdditionalImage1Src: this.state.productAdditionalImage1Src,
          productAdditionalImage2Src: this.state.productAdditionalImage2Src,
          productAdditionalImage3Src: this.state.productAdditionalImage3Src,
          productAdditionalImage4Src: this.state.productAdditionalImage4Src,
          terms: this.state.terms,
          overrideStartingPrice: this.state.overrideStartingPrice,
          // providerId: this.state.providerId,
          customAttributes: this.state.customAttributes,
          providerId: this.props.providerId,
        },
        tab,
      );
    }, 500);
  };

  back = () => {
    if (
      this.state.activeTab !== 0 &&
      this.state.activeTab !== 1 &&
      this.state.activeTab !== 2
    ) {
      const nextTab = this.state.activeTab - 1;
      this.handleChange("", nextTab);
      this.setState({
        activeTab: nextTab,
      });
    } else if (this.state.activeTab === 1) {
      const nextTab = 5;
      this.handleChange("", nextTab);
      this.setState({
        activeTab: nextTab,
      });
    } else if (this.state.activeTab === 2) {
      const nextTab = 0;
      this.handleChange("", nextTab);
      this.setState({
        activeTab: nextTab,
      });
    }
  };

  next = (tab) => {
    // this.handleEditor();
    var localisedNameIndex = this.state.localisedName.findIndex(
      (x) => x.locale === "en_US",
    );
    var localisedDescIndex = this.state.localisedDesc.findIndex(
      (x) => x.locale === "en_US",
    );

    setTimeout(() => {
      let errorArray = [];
      if (!this.state.productName) {
        errorArray.push("productName");
      }
      if (!this.state.featureCode) {
        errorArray.push("featureCode");
      }
      if (!this.state.productDescription) {
        errorArray.push("productDescription");
      }
      if (!this.state.startingPrice) {
        errorArray.push("startingPrice");
      }
      if (!this.state.categoryId) {
        errorArray.push("categoryId");
      }
      if (!this.state.productMainImage && !this.props.disableInputFields) {
        errorArray.push("productMainImage");
      }
      this.setState({
        fieldsWithError: errorArray,
      });
      if (
        this.state.activeTab !== 0 &&
        this.state.activeTab !== 1 &&
        this.state.activeTab !== 5
      ) {
        const nextTab = this.state.activeTab + 1;
        this.handleChange("", nextTab);
        this.setState({
          activeTab: nextTab,
        });
      } else if (
        this.state.activeTab === 5 &&
        this.props.showCustomAttributes
      ) {
        const nextTab = 1;
        this.handleChange("", nextTab);
        this.setState({
          activeTab: nextTab,
        });
        // const nextTab = 2;
        // this.handleChange('', nextTab);
        // this.setState({
        //     activeTab: nextTab
        // });
      } else if (this.state.activeTab === 0) {
        const nextTab = 2;
        this.handleChange("", nextTab);
        this.setState({
          activeTab: nextTab,
        });
      } else if (
        this.state.activeTab === 1 ||
        !this.props.showCustomAttributes
      ) {
        if (
          localisedNameIndex == -1 ||
          (localisedNameIndex > -1 &&
            this.state.localisedName[localisedNameIndex].text == "") ||
          localisedDescIndex == -1 ||
          (localisedDescIndex > -1 &&
            this.state.localisedDesc[localisedDescIndex].text == "")
        ) {
          this.props.setErrorMessage(this.props.t("LANGUAGE_ERROR"), false);
          return;
        }

        if (
          !this.state.productName ||
          !this.state.featureCode ||
          !this.state.productDescription ||
          !this.state.startingPrice ||
          !this.state.categoryId ||
          (!this.state.productMainImage && !this.props.disableInputFields)
          // || (this.props.packageMode != "edit" && !this.state.productMainImageSource)
        ) {
          this.props.setErrorMessage(
            this.props.t("BASIC_DETAILS_ERROR"),
            false,
          );
        } else {
          this.setState({ loading: true });
          if (this.props.packageMode !== "edit") {
            let productEncodedName = UriEncode(this.state.productName);
            // BusApiCall('GET', `${constants.busInternalUrl}/packaged-solutions/products/${productEncodedName}`).then(res => {
            //     //SoapCall("validatePackageName", null, { productName: this.state.productName }, false, 2).then(res => {
            //     if (res.data[0].errorMessage) {
            //         this.props.setErrorMessage(res.data[0].errorMessage, false)
            //         // this.props.disableTabs();
            //         this.setState({ loading: false })
            //     } else {
            //         this.props.getPackageBasicDetails(
            //             {
            //                 bom: this.state.bom,
            //                 productName: this.state.productName,
            //                 categoryId: this.state.categoryId,
            //                 //partnerId: partnerId,
            //                 localisedName: this.state.localisedName,
            //                 localisedDesc: this.state.localisedDesc,
            //                 localisedOverview: this.state.localisedOverview,
            //                 localisedTechSpecs: this.state.localisedTechSpecs,
            //                 localisedWhatsIncluded: this.state.localisedWhatsIncluded,
            //                 featureCode: this.state.featureCode,
            //                 productDescription: this.state.productDescription,
            //                 startingPrice: this.state.startingPrice,
            //                 originalStartingPrice: this.state.originalStartingPrice,
            //                 productOverview: JSON.stringify(convertToRaw(this.state.productOverviewState.getCurrentContent())),
            //                 productTechSpecs: JSON.stringify(convertToRaw(this.state.productTechSpecsState.getCurrentContent())),
            //                 productWhatsIncluded: JSON.stringify(convertToRaw(this.state.productWhatsIncludedState.getCurrentContent())),
            //                 productMainImage: this.state.productMainImage,
            //                 productMainImageSource: this.state.productMainImageSource,
            //                 productAdditionalImage1: this.state.productAdditionalImage1,
            //                 productAdditionalImage2: this.state.productAdditionalImage2,
            //                 productAdditionalImage3: this.state.productAdditionalImage3,
            //                 productAdditionalImage4: this.state.productAdditionalImage4,
            //                 productAdditionalImage1Src: this.state.productAdditionalImage1Src,
            //                 productAdditionalImage2Src: this.state.productAdditionalImage2Src,
            //                 productAdditionalImage3Src: this.state.productAdditionalImage3Src,
            //                 productAdditionalImage4Src: this.state.productAdditionalImage4Src,
            //                 terms: this.state.terms,
            //                 overrideStartingPrice: this.state.overrideStartingPrice,
            //                 customAttributes: this.state.customAttributes,
            //                 providerId: this.props.providerId
            //             },
            //             tab
            //         )
            //         this.setState({ loading: false })
            //     }
            // })
            //     .catch(err => {
            //         if (err.response && err.response.data && err.response.data.message) {
            //             this.props.setErrorMessage(err.response.data.message, false)
            //         } else {
            //             this.props.setErrorMessage(this.props.t('DEFAULT_ERROR_MESSAGE'), false)
            //         }
            //         this.setState({ loading: false })
            //     })
            this.props.getPackageBasicDetails(
              {
                bom: this.state.bom,
                productName: this.state.productName,
                categoryId: this.state.categoryId,
                //partnerId: partnerId,
                localisedName: this.state.localisedName,
                localisedDesc: this.state.localisedDesc,
                localisedOverview: this.state.localisedOverview,
                localisedTechSpecs: this.state.localisedTechSpecs,
                localisedWhatsIncluded: this.state.localisedWhatsIncluded,
                featureCode: this.state.featureCode,
                productDescription: this.state.productDescription,
                startingPrice: this.state.startingPrice,
                originalStartingPrice: this.state.originalStartingPrice,
                // productOverview: JSON.stringify(
                //   convertToRaw(
                //     this.state.productOverviewState.getCurrentContent(),
                //   ),
                // ),
                // productTechSpecs: JSON.stringify(
                //   convertToRaw(
                //     this.state.productTechSpecsState.getCurrentContent(),
                //   ),
                // ),
                // productWhatsIncluded: JSON.stringify(
                //   convertToRaw(
                //     this.state.productWhatsIncludedState.getCurrentContent(),
                //   ),
                // ),
                productOverview: this.state.productOverview,
                productTechSpecs: this.state.productTechSpecs,
                productWhatsIncluded: this.state.productWhatsIncluded,
                productMainImage: this.state.productMainImage,
                productMainImageSource: this.state.productMainImageSource,
                productAdditionalImage1: this.state.productAdditionalImage1,
                productAdditionalImage2: this.state.productAdditionalImage2,
                productAdditionalImage3: this.state.productAdditionalImage3,
                productAdditionalImage4: this.state.productAdditionalImage4,
                productAdditionalImage1Src:
                  this.state.productAdditionalImage1Src,
                productAdditionalImage2Src:
                  this.state.productAdditionalImage2Src,
                productAdditionalImage3Src:
                  this.state.productAdditionalImage3Src,
                productAdditionalImage4Src:
                  this.state.productAdditionalImage4Src,
                terms: this.state.terms,
                overrideStartingPrice: this.state.overrideStartingPrice,
                customAttributes: this.state.customAttributes,
                providerId: this.props.providerId,
              },
              tab,
            );
            this.setState({ loading: false });
          } else {
            this.props.getPackageBasicDetails(
              {
                bom: this.state.bom,
                productName: this.state.productName,
                categoryId: this.state.categoryId,
                localisedName: this.state.localisedName,
                localisedDesc: this.state.localisedDesc,
                localisedOverview: this.state.localisedOverview,
                localisedTechSpecs: this.state.localisedTechSpecs,
                localisedWhatsIncluded: this.state.localisedWhatsIncluded,
                featureCode: this.state.featureCode,
                productDescription: this.state.productDescription,
                startingPrice: this.state.startingPrice,
                originalStartingPrice: this.state.originalStartingPrice,
                // productOverview: JSON.stringify(
                //   convertToRaw(
                //     this.state.productOverviewState.getCurrentContent(),
                //   ),
                // ),
                // productTechSpecs: JSON.stringify(
                //   convertToRaw(
                //     this.state.productTechSpecsState.getCurrentContent(),
                //   ),
                // ),
                // productWhatsIncluded: JSON.stringify(
                //   convertToRaw(
                //     this.state.productWhatsIncludedState.getCurrentContent(),
                //   ),
                // ),
                productOverview: this.state.productOverview,
                productTechSpecs: this.state.productTechSpecs,
                productWhatsIncluded: this.state.productWhatsIncluded,
                productMainImage: this.state.productMainImage,
                productMainImageSource: this.state.productMainImageSource,
                productAdditionalImage1: this.state.productAdditionalImage1,
                productAdditionalImage2: this.state.productAdditionalImage2,
                productAdditionalImage3: this.state.productAdditionalImage3,
                productAdditionalImage4: this.state.productAdditionalImage4,
                productAdditionalImage1Src:
                  this.state.productAdditionalImage1Src,
                productAdditionalImage2Src:
                  this.state.productAdditionalImage2Src,
                productAdditionalImage3Src:
                  this.state.productAdditionalImage3Src,
                productAdditionalImage4Src:
                  this.state.productAdditionalImage4Src,
                terms: this.state.terms,
                overrideStartingPrice: this.state.overrideStartingPrice,
                customAttributes: this.state.customAttributes,
                providerId: this.props.providerId,
              },
              tab,
            );
          }
        }
      }
    }, 500);
  };

  resetErrroInput = (input) => {
    let inputs = [...this.state.fieldsWithError];
    const index = inputs.indexOf(input);
    if (index > -1) {
      inputs.splice(index, 1);
    }
    this.setState({
      fieldsWithError: [...inputs],
    });
  };

  updateMargin = (e) => {
    if (e.target.value > -1000 && e.target.value < 1000) {
      let bdCopy = { ...this.props.basicDetail };
      let price = bdCopy.originalStartingPrice;
      let margin = ((price / 100) * e.target.value).toFixed(2);
      let newPrice = (JSON.parse(price) + JSON.parse(margin)).toFixed(2) + "";
      this.setState({
        startingPrice: newPrice,
      });
      this.props.updateMargin(e.target.value);
    } else {
      this.props.setErrorMessage(this.props.t("MARGIN_MIN_MAX_ERROR"), false);
    }
  };

  onChangeAttribute = (e) => {
    var tempList = [...this.state.customAttributes];
    var index = tempList.findIndex(
      (x) => !x.delete && x.attrName === e.target.name,
    );
    if (index > -1) {
      if (tempList[index].valueType === "boolean") {
        if (tempList[index].attrValue) {
          tempList[index].attrValue = false;
        } else {
          tempList[index].attrValue = true;
        }
      } else {
        tempList[index].attrValue = e.target.value;
      }
      if (tempList[index].productId) {
        tempList[index].update = true;
      }
      this.setState({
        customAttributes: tempList,
      });
    }
  };

  removeAttribute = (item) => {
    var tempList = [...this.state.customAttributes];
    var index = tempList.findIndex(
      (x) => !x.delete && x.attrName === item.attrName,
    );
    if (index > -1) {
      this.props.blockNavigation();
      var opt = {
        attrName: item.attrName,
        required: false,
        valueType: item.valueType,
        options: item.options ? item.options : [],
      };
      if (opt.valueType === "boolean") {
        opt.attrValue = false;
      } else {
        opt.attrValue = "";
      }
      var tempCustomAttributesList = [...this.state.customAttributesList];
      tempCustomAttributesList.push(opt);
      tempCustomAttributesList = tempCustomAttributesList.sort((a, b) =>
        a && b && a.attrName > b.attrName
          ? 1
          : b.attrName > a.attrName
            ? -1
            : 0,
      );
      this.setState({
        customAttributesList: tempCustomAttributesList,
      });
      if (item.productId) {
        tempList[index].delete = true;
        tempList[index].update = false;
        this.setState({
          customAttributes: tempList,
        });
      } else {
        tempList.splice(index, 1);
        this.setState({
          customAttributes: tempList,
        });
      }
    }
  };

  selectAttribute = (e) => {
    this.props.blockNavigation();
    this.setState({
      tempSelectedAttribute: e,
    });
  };

  addAttribute = () => {
    if (this.state.tempSelectedAttribute.attrName) {
      this.props.blockNavigation();
      var customAttributes = [...this.state.customAttributes];
      var item = this.state.tempSelectedAttribute;
      if (this.props.packageMode === "edit") {
        item.create = true;
      }
      customAttributes.push(item);

      var tempList = [...this.state.customAttributesList];
      var index = tempList.findIndex(
        (x) => x.attrName === this.state.tempSelectedAttribute.attrName,
      );
      if (index > -1) {
        tempList.splice(index, 1);
      }

      this.setState({
        customAttributes,
        tempSelectedAttribute: {},
        customAttributesList: tempList,
      });
    }
  };

  onChangeOverview = (productOverviewState) => {
    // this.props.blockNavigation();
    this.setState(
      {
        // productOverviewState,
        // productOverview: JSON.stringify(
        //   convertToRaw(productOverviewState.getCurrentContent()),
        // ),
        productOverview: productOverviewState
      },
      () => {
        this.setInputTextBasedOnLocale(
          "productOverview",
          productOverviewState,
        );
      },
    );
  };
  onChangeTechSpecs = (productTechSpecsState) => {
    // this.props.blockNavigation();
    this.setState(
      {
        // productTechSpecsState,
        // productTechSpecs: JSON.stringify(
        //   convertToRaw(productTechSpecsState.getCurrentContent()),
        // ),
        productTechSpecs: productTechSpecsState
      },
      () => {
        this.setInputTextBasedOnLocale(
          "productTechSpecs",
          productTechSpecsState,
        );
      },
    );
  };
  onChangeWhatsIncluded = (productWhatsIncludedState) => {
    // this.props.blockNavigation();
    this.setState(
      {
        // productWhatsIncludedState,
        // productWhatsIncluded: JSON.stringify(
        //   convertToRaw(productWhatsIncludedState.getCurrentContent()),
        // ),
        productWhatsIncluded: productWhatsIncludedState
      },
      () => {
        this.setInputTextBasedOnLocale(
          "productWhatsIncluded",
          productWhatsIncludedState,
        );
      },
    );
  };

  handlePastedText = async (text, html) => {
    // const editorState = this.state.productOverviewState;

    // var initialData = JSON.parse(this.state.productOverview);
    // var convertedInitialData = convertFromRaw(initialData);
    // this.setState({
    //     productOverviewState: EditorState.createWithContent(convertedInitialData)
    // })
    // const blockMap = stateFromHTML(html).blockMap
    // const newState = Modifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), blockMap)
    // this.onChangeEditorState(EditorState.push(editorState, newState, 'insert-fragment'))
    // return true

    //     let newState = handleDraftEditorPastedText(html, editorState);
    //     if (newState) {
    //         this.onChange(newState);
    //         return true;
    //     }
    //     return false;
  };

  render() {
    // const defaultTheme = createTheme()
    // Object.assign(defaultTheme, {
    //     overrides: {
    //         MUIRichTextEditor: {
    //             editor: {
    //                 borderBottom: "1px solid gray",
    //                 borderTop: "1px solid gray"
    //             }
    //         }
    //     }
    // })
    const {
      onChange,
      onImageChange,
      save,
      overrideStartingPrice,
      resetErrroInput,
      updateMargin,
    } = this;
    const { tabValue, showBucketsOnLeft } = this.state;
    const mandatoryMessage = {
      color: "#f44336",
      fontSize: "12px",
      lineHeight: "64px",
    };

    const mandatoryMessageShort = {
      color: "#f44336",
      fontSize: "12px",
    };
    const { activeTab } = this.state;
    const { t, isMobile, showCategory, classes } = this.props;

    const tabs = [
      { text: t("BASIC_DETAILS"), value: 0 },
      { text: t("OVERVIEW"), value: 2 },
      { text: t("TECH_SPECS"), value: 3 },
      { text: t("WHAT_IS_INCLUDED"), value: 4 },
      { text: t("ADDITIONAL_IMAGES"), value: 5 },
      this.props.showCustomAttributes && { text: t("CUSTOM_ATTRIBUTES"), value: 1 },
    ].filter(Boolean);
    const stepsList = (
      <>
        <Grid
          item
          style={{ borderRight: "1px solid lightgrey", padding: "1rem" }}
          size={{
            xs: 12,
            md: 3,
          }}
        >
          {/* tabs */}
          <List>
            {[
              { text: t("BASIC_DETAILS"), value: 0 },
              { text: t("OVERVIEW"), value: 2 },
              { text: t("TECH_SPECS"), value: 3 },
              { text: t("WHAT_IS_INCLUDED"), value: 4 },
              { text: t("ADDITIONAL_IMAGES"), value: 5 },
              this.props.showCustomAttributes && {
                text: t("CUSTOM_ATTRIBUTES"),
                value: 1,
              },
            ]
              .filter(Boolean)
              .map((tab, index) => (
                <React.Fragment key={index}>
                  <ListItem
                    button
                    key={tab.text}
                    // className={
                    //   activeTab === tab.value
                    //     ? classes.selected
                    //     : classes.listItem
                    // }
                    onClick={(e) => {
                      this.handleChange(e, tab.value);
                      this.setState({
                        activeTab: tab.value,
                      });
                      this.props.toggleShowCategory(0);
                    }}
                  // style={{
                  //     borderLeft: activeTab === tab.value ? `2px solid ${this.props.tenantData.color}` : `2px solid white`,
                  //     fontWeight: activeTab === tab.value ? 'bold' : 'normal',
                  //     display: 'flex', justifyContent: 'space-between', alignItems: 'center'
                  // }}
                  >
                    <ListItemText
                      // style={{ color: activeTab === tab.value ? this.props.tenantData.color : "inherit" }}
                      primary={tab.text}
                    />
                  </ListItem>
                </React.Fragment>
              ))}
          </List>
        </Grid>
      </>
    )

    const basicDetailsTab = () => {
      return (
          <>
           <Grid item size={{ xs: 12, md: 12}} style={{ padding: '1rem', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', gap: '1rem', height: '100%' }}>
                              {tabValue === 0 && this.props.packageMode !== 'promo' &&
                                  <div >
                                      {isMobile &&
                                          <h3>
                                              {t("BASIC_DETAILS")}
                                          </h3>
                                      }
                                      <Grid container spacing={3} justifyContent="center" alignItems="center" style={{ justifyContent: 'center' }}>
                                          <Grid item size={{ xs: 12, md: 8}}>
                                              {/* {(this.props.enabledModules.INVENTORY && this.props.enabledModules.INVENTORY.enabled) &&
                                  <FormControlLabel style={{ marginLeft: '2px' }}
                                      control={
                                          <Checkbox
                                              checked={this.state.bom}
                                              onChange={event => this.isBom(event)}
                                              name={'bom'}
                                              color="primary"
                                          />
                                      }
                                      label={t('IS_BOM')}
                                  />
                              } */}
                                          </Grid>
                                          <Grid item size={{ xs: 4, md: 4}}>
                                              {/* <FormControl variant="outlined" className="custom-select-input" size={'small'}>
                                  <InputLabel id="language" htmlFor="outlined-age-native-simple"> {t('SELECT_LANGUAGE') + ' *'}</InputLabel>
                                  <Select
                                      native
                                      label='Select Language'
                                      labelId="language"
                                      value={this.state.language}
                                      onChange={event => this.onLanguageChange(event)}
                                      inputProps={{
                                          name: 'language',
                                          id: 'language',
                                      }}
                                  >
                                      <option value="en_US">{t('English')}</option>
                                      <option value="spanish">{t('Spanish')}</option>
                                      <option value="en_FR">{t('French')}</option>
                                  </Select>
                              </FormControl> */}
                                          </Grid>
                                          <Grid item size={{ xs: 12, md: 4}}>
                                              <Input
                                                  name={'productName'}
                                                  value={this.state.productName}
                                                  variant={'outlined'}
                                                  onChange={event => onChange(event)}
                                                  placeholder={t('NAME') + ' *'}
                                                  size={'small'}
                                                  onKeyDown={event => resetErrroInput('productName')}
                                                  className={this.state.fieldsWithError.includes('productName') ? classes.errorInputClass : ''}
                                                  disabled={this.props.disableInputFields}
                                              />
                                          </Grid>

                                          <Grid item size={{ xs: 12, md: 4}}>
                                              <Input
                                                  name={'featureCode'}
                                                  value={this.state.featureCode}
                                                  variant={'outlined'}
                                                  onChange={event => onChange(event)}
                                                  placeholder={t('FEATURE_CODE') + ' *'}
                                                  size={'small'}
                                                  onKeyDown={event => resetErrroInput('featureCode')}
                                                  className={this.state.fieldsWithError.includes('featureCode') ? classes.errorInputClass : ''}
                                                  disabled={this.props.disableInputFields}
                                              />
                                          </Grid>

                                          <Grid item size={{ xs: 12, md: 4}}>
                                              {this.state.showCategory &&
                                                  <FormControl variant="outlined" className="custom-select-input" size={'small'}>
                                                      <InputLabel htmlFor="outlined-age-native-simple">
                                                          {t('SELECT_PACKAGE_SOLUTION_CATEGORY')} *</InputLabel>
                                                      <Select
                                                          native
                                                          label='select_package_solution_category *'
                                                          value={this.state.categoryId}
                                                          onChange={event => { onChange(event); resetErrroInput('categoryId') }}
                                                          inputProps={{
                                                              name: 'categoryId',
                                                              id: 'outlined-age-native-simple',
                                                          }}
                                                          className={this.state.fieldsWithError.includes('categoryId') ? classes.errorInputClass : ''}
                                                          disabled={this.props.disableInputFields}
                                                      >
                                                          <option value="" disabled></option>
                                                          {this.state.categoryList
                                                              .sort((a, b) => a.categoryName - b.categoryName)
                                                              .map(opt => (
                                                                  <option key={opt.categoryId} value={opt.categoryId}>{opt.categoryName}</option>
                                                              ))}
                                                      </Select>
                                                  </FormControl>
                                              }
                                          </Grid>
                                          <Grid item size={{ xs: 12, md: 12}}>
                                              <Input
                                                  name={'productDescription'}
                                                  value={this.state.productDescription}
                                                  onChange={event => onChange(event)}
                                                  placeholder={t('DESCRIPTION') + ' *'}
                                                  variant={'outlined'}
                                                  size={'small'}
                                                  onKeyDown={event => resetErrroInput('productDescription')}
                                                  className={this.state.fieldsWithError.includes('productDescription') ? classes.errorInputClass : ''}
                                                  inputProps={{ rows: 1, cols: 31 }}
                                                  multiline={true}
                                                  disabled={this.props.disableInputFields}
                                              />
                                          </Grid>
                                          <Grid item size={{ xs: 12, md: 6}}>
                                              <Input
                                                  name={'startingPrice'}
                                                  value={this.state.startingPrice}
                                                  onChange={event => onChange(event)}
                                                  placeholder={`${t('STARTING_PRICE')} * : (${currencyFormatter('', false)})`}
                                                  type={'number'}
                                                  min={1} size={'small'}
                                                  variant={'outlined'}
                                                  disabled={this.props.disableInputFields}
                                                  onKeyDown={event => {
                                                      resetErrroInput('startingPrice');
                                                      //Intercept the letter 'e' and prevent its default behaviour
                                                      if (event.keyCode === 69) {
                                                          event.preventDefault();
                                                      }
                                                  }}
                                                  className={this.state.fieldsWithError.includes('startingPrice') ? classes.errorInputClass : ''}
                                              />
                                          </Grid>
                                          <Grid item size={{ xs: 12, md: 6}}>
                                              {this.props.providerType !== 'SALES_CHNL_PROVIDER' &&
                                                  <FormControlLabel
                                                      control={
                                                          <Checkbox
                                                              checked={this.state.overrideStartingPrice}
                                                              onChange={event => overrideStartingPrice(event)}
                                                              name={'overrideStartingPrice'}
                                                              color="primary"
                                                              disabled={this.props.disableInputFields}
                                                          />
                                                      }
                                                      label={t('OVERWRITE_STARTING_PRICE_IN_SALES_PORTAL')}
                                                  />
                                              }

                                              {this.props.addToCatalog === 'true' &&
                                                  <>
                                                      {/* <Input
                                          name={'margin'}
                                          value={this.props.margin}
                                          onChange={event => updateMargin(event)}
                                          onKeyDown={event => {
                                              // Intercept the letter "e" (Key code 69) and prevent its default behavior
                                              if (event.keyCode === 69) {
                                                  event.preventDefault();
                                              }
                                          }}
                                          placeholder={`${t('SET_MARGIN')}`}
                                          type={'number'}
                                          size={'small'}
                                          variant={'outlined'}
                                          style={{ maxWidth: '130px', float: 'left', marginRight: '10px' }}
                                      // onKeyDown={event => resetErrroInput('startingPrice')}
                                      // className={this.state.fieldsWithError.includes('startingPrice') ? classes.errorInputClass : ''}
                                      />
                                      <label style={mandatoryMessageShort}>
                                          {t('RESET_MARGIN')}
                                      </label> */}
                                                  </>
                                              }
                                          </Grid>

                                          {/* <Grid item xs={6}>
                      </Grid>
                      <Grid item xs={6}>
                          <label style={mandatoryMessageShort}>
                              {t('RESET_MARGIN')}
                          </label>
                      </Grid> */}

                                          {this.props.packageMode === 'edit' ?
                                              <Grid item size={{ xs: 12, md: 12}}>
                                                  <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                                                      <div>
                                                          {this.state.productMainImageSource ?
                                                              <img
                                                                  width="50"
                                                                  height="50"
                                                                  border="0"
                                                                  src={this.state.productMainImageSource}
                                                                  className={imageClass.cardImage}
                                                                  alt=""
                                                              //disabled={this.props.providerType === 'SALES_CHNL_PROVIDER'}
                                                              />
                                                              :
                                                              <img
                                                                  width="50"
                                                                  height="50"
                                                                  border="0"
                                                                  //src={constants.imageUrl + this.props.images[0]}
                                                                  className={imageClass.cardImage}
                                                                  alt=""
                                                              //disabled={this.props.providerType === 'SALES_CHNL_PROVIDER'}
                                                              />
                                                          }

                                                      </div>
                                                      <div>
                                                          <Input
                                                              inputProps={{ id: "productMainImage" }}
                                                              name={'productMainImage'}
                                                              type="file"
                                                              className="custom-file-input"
                                                              onChange={event => onImageChange(event, "productMainImageSource")}
                                                              source={this.state.productMainImageSource}
                                                              disabled={this.props.disableInputFields}
                                                          //disabled={this.props.providerType === 'SALES_CHNL_PROVIDER'}
                                                          />
                                                          <label disabled={this.props.providerType === 'SALES_CHNL_PROVIDER'} htmlFor="productMainImage" className={'input-file-label'} style={{ background: 'transparent', maxWidth: isMobile ? '300px' : 'auto', overflow: 'overlay' }}>
                                                              <Icon>attach_file</Icon>
                                                              <label>
                                                                  {this.state.productMainImage ? this.state.productMainImage : <span className="input-file-placeholder">{t('PRODUCT_MAIN_IMAGE')} {t('IMAGE_SIZE_MESSAGE')} *</span>}
                                                              </label>
                                                          </label>
                                                      </div>
                                                  </div>
                                              </Grid>
                                              :
                                              <>
                                                  <Grid item size={{ xs: 12, md: 12}}>
                                                      <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                                                          <div>
                                                              <label htmlFor="productMainImage">
                                                                  {this.state.productMainImageSource ?
                                                                      <img
                                                                          width="50"
                                                                          height="50"
                                                                          border="0"
                                                                          src={this.state.productMainImageSource}
                                                                          className={imageClass.cardImage}
                                                                          alt=""
                                                                      />
                                                                      :
                                                                      <img
                                                                          width="50"
                                                                          height="50"
                                                                          border="0"
                                                                          src={placeholderImage}
                                                                          className={imageClass.cardImage}
                                                                          alt=""
                                                                      />
                                                                  }
                                                              </label>
                                                          </div>
                                                          <div>
                                                              <Input
                                                                  inputProps={{ id: "productMainImage" }}
                                                                  name={'productMainImage'}
                                                                  type="file"
                                                                  className="custom-file-input"
                                                                  onChange={event => { onImageChange(event, "productMainImageSource"); resetErrroInput('productMainImage') }}
                                                                  source={this.state.productMainImageSource}
                                                                  disabled={this.props.disableInputFields}
                                                              />
                                                              <label htmlFor="productMainImage" className={'input-file-label ' + (this.state.fieldsWithError.includes('productMainImage') ? classes.errorImageInputClass : '')} style={{ maxWidth: isMobile ? '300px' : 'auto', overflow: 'overlay' }}>
                                                                  <Icon>attach_file</Icon>
                                                                  <label>
                                                                      {this.state.productMainImage ? this.state.productMainImage : <span className="input-file-placeholder">{t('PRODUCT_MAIN_IMAGE')} {t('IMAGE_SIZE_MESSAGE')} *</span>}
                                                                  </label>
                                                              </label>
                                                          </div>
                                                      </div>
                                                  </Grid>
                                              </>
                                          }
                                      </Grid>
                                  </div>}
                              {tabValue === 1 &&
                                  <>
                                      {isMobile &&
                                          <h3>
                                              {t("CUSTOM_ATTRIBUTES")}
                                          </h3>
                                      }
                                      <Grid container spacing={2} justifyContent="center" alignItems="center" style={{ justifyContent: 'center' }}>
                                          <Grid item size={{ xs: 12, md: 12}}>
                                              <CustomAttributes
                                                  list={this.state.customAttributesList}
                                                  selectAttribute={this.selectAttribute}
                                                  data={this.state.customAttributes}
                                                  addAttribute={this.addAttribute}
                                                  tempSelectedAttribute={this.state.tempSelectedAttribute}
                                                  onChangeAttribute={this.onChangeAttribute}
                                                  removeAttribute={this.removeAttribute}
                                                  disableInputFields={this.props.disableInputFields}
                                              />
                                          </Grid>
                                      </Grid>
                                  </>
                              }

                              {
                                  tabValue === 2 &&
                                  <>
                                      {isMobile &&
                                          <h3>
                                              {t("OVERVIEW")}
                                          </h3>
                                      }
                                      <Grid container spacing={3} justifyContent='center'>
                                          <Grid item size={{ xs: 12, md: 12}} align='right'>
                                              {/* <FormControl variant="outlined" className="custom-select-input" size={'small'} style={{ float: 'right', width: '200px' }}>
                              <InputLabel id="languageOverview" htmlFor="outlined-age-native-simple"> {t('SELECT_LANGUAGE') + ' *'}</InputLabel>
                              <Select
                                  native
                                  label='SELECT_LANGUAGE'
                                  labelId="languageOverview"
                                  value={this.state.languageOverview}
                                  onChange={event => this.onLanguageChange(event)}
                                  inputProps={{
                                      name: 'languageOverview',
                                      id: 'languageOverview',
                                  }}
                              >
                                  <option value="" disabled>{t('SELECT_LANGUAGE') + ' *'}</option>
                                  <option value="en_US">{t('English')}</option>
                                  <option value="spanish">{t('Spanish')}</option>
                                  <option value="en_FR">{t('French')}</option>
                              </Select>
                          </FormControl>  */}
                                          </Grid>

                                          <Grid item size={{ xs: 12, md: 12}}>
                                          <TiptapEditor
                                            value={this.state.productOverview}
                                            onChange={this.onChangeOverview}
                                            placeholder={t("ENTER_PRODUCT_OVERVIEW_CONTENT_HERE")}
                                            readOnly={this.props.disableInputFields}
                                          />
                                              {/* <Editor
                                  // ref={this.setEditor}
                                  editorState={this.state.productOverviewState}
                                  onEditorStateChange={this.onChangeEditorState}
                                  onCopy={onDraftEditorCopy}
                                  onCut={onDraftEditorCut}
                                  handlePastedText={this.handlePastedText}
                                  readOnly={true}
                                  toolbarClassName={' hide-editor-toolbar'}
                                  toolbar={{
                                      image: {
                                          uploadCallback: (file) => {
                                              return new Promise((resolve, reject) => {
                                                  const reader = new FileReader();
                                                  reader.readAsDataURL(file);
                                                  reader.onload = () => {
                                                      const dataURL = reader.result;
                                                      const truncatedDataURL = dataURL.substring(10, 30) + "..."; // set the maximum length of the truncated string
                                                      resolve({ data: { link: dataURL }, link: { url: truncatedDataURL } });
                                                  };
                                                  reader.onerror = (error) => {
                                                      reject(error);
                                                  };
                                              });
                                          },
                                          alt: { present: true, mandatory: false },
                                          previewImage: true
                                      }
                                  }}
                              /> */}
                                          </Grid>
                                      </Grid>
                                  </>
                              }

                              {
                                  tabValue === 3 &&
                                  <>
                                      {isMobile &&
                                          <h3>
                                              {t("TECH_SPECS")}
                                          </h3>
                                      }
                                      <Grid container spacing={3} justifyContent='center'>
                                          <Grid item size={{ xs: 12, md: 12}} align='center'>
                                              {/* <FormControl variant="outlined" className="custom-select-input" size={'small'} style={{ float: 'right', width: '200px' }}>
                              <InputLabel id="languageTechSpecs" htmlFor="outlined-age-native-simple"> {t('SELECT_LANGUAGE') + ' *'}</InputLabel>
                              <Select
                                  native
                                  label='SELECT_LANGUAGE'
                                  labelId="languageTechSpecs"
                                  value={this.state.languageTechSpecs}
                                  onChange={event => this.onLanguageChange(event)}
                                  inputProps={{
                                      name: 'languageTechSpecs',
                                      id: 'languageTechSpecs',
                                  }}
                              >
                                  <option value="" disabled>{t('SELECT_LANGUAGE') + ' *'}</option>
                                  <option value="en_US">{t('English')}</option>
                                  <option value="spanish">{t('Spanish')}</option>
                                  <option value="en_FR">{t('French')}</option>
                              </Select>
                          </FormControl>  */}
                                          </Grid>

                                          <Grid item size={{ xs: 12, md: 12}}>
                                          <TiptapEditor
                                            value={this.state.productTechSpecsState}
                                            onChange={this.onChangeTechSpecs}
                                            placeholder={t(
                                              "ENTER_PRODUCT_TECHNICAL_SPECIFICAIONS_HERE",
                                            )}
                                            readOnly={this.props.disableInputFields}
                                          />
                                          </Grid>
                                      </Grid>
                                  </>
                              }

                              {
                                  tabValue === 4 &&
                                  <>
                                      {isMobile &&
                                          <h3>
                                              {t("WHAT_IS_INCLUDED")}
                                          </h3>
                                      }
                                      <Grid container spacing={3} justifyContent='center'>
                                          <Grid item size={{ xs: 12, md: 12}} align='right'>
                                              {/* <FormControl variant="outlined" className="custom-select-input" size={'small'} style={{ float: 'right', width: '200px' }}>
                              <InputLabel id="languageWhatsIncluded" htmlFor="outlined-age-native-simple"> {t('SELECT_LANGUAGE') + ' *'}</InputLabel>
                              <Select
                                  native
                                  label='SELECT_LANGUAGE'
                                  labelId="languageWhatsIncluded"
                                  value={this.state.languageWhatsIncluded}
                                  onChange={event => this.onLanguageChange(event)}
                                  inputProps={{
                                      name: 'languageWhatsIncluded',
                                      id: 'languageWhatsIncluded',
                                  }}
                              >
                                  <option value="" disabled>{t('SELECT_LANGUAGE') + ' *'}</option>
                                  <option value="en_US">{t('English')}</option>
                                  <option value="spanish">{t('Spanish')}</option>
                                  <option value="en_FR">{t('French')}</option>
                              </Select>
                          </FormControl>  */}
                                          </Grid>

                                          <Grid item size={{ xs: 12, md: 12}}>
                                          <TiptapEditor
                                            value={this.state.productWhatsIncludedState}
                                            onChange={this.onChangeWhatsIncluded}
                                            placeholder={t(
                                              "ENTER_WHAT_IS_INCLUDED_TEXT_HERE",
                                            )}
                                            readOnly={this.props.disableInputFields}
                                          />
                                          </Grid>
                                      </Grid>
                                  </>
                              }

                              {
                                  tabValue === 5 && this.props.packageMode !== 'edit' &&
                                  <>
                                      {isMobile &&
                                          <h3>
                                              {t("ADDITIONAL_IMAGES")}
                                          </h3>
                                      }
                                      <Grid container spacing={3} justifyContent='center'>
                                          <Grid item size={{ xs: 12, md: 12}}>
                                              <Input
                                                  name={'productAdditionalImage1'}
                                                  onChange={event => onImageChange(event, "productAdditionalImage1Src")}
                                                  inputProps={{ id: "productAdditionalImage1" }}
                                                  // placeholder={'Image'}
                                                  type="file"
                                                  className="custom-file-input"
                                                  source={this.state.productAdditionalImage1Src}
                                                  disabled={this.props.disableInputFields}
                                              />
                                              <label htmlFor="productAdditionalImage1" className="input-file-label">
                                                  <Icon>attach_file</Icon>
                                                  <label>
                                                      {this.state.productAdditionalImage1 ? this.state.productAdditionalImage1 : <span className="input-file-placeholder">{t('PRODUCT_IMAGE')} {t('IMAGE_SIZE_MESSAGE')}</span>}
                                                  </label>
                                              </label>
                                          </Grid>
                                          <Grid item size={{ xs: 12, md: 12}}>
                                              <Input
                                                  name={'productAdditionalImage2'}
                                                  onChange={event => onImageChange(event, "productAdditionalImage2Src")}
                                                  inputProps={{ id: "productAdditionalImage2" }}
                                                  // placeholder={'Image'}
                                                  type="file"
                                                  className="custom-file-input"
                                                  source={this.state.productAdditionalImage2Src}
                                                  disabled={this.props.disableInputFields}
                                              />
                                              <label htmlFor="productAdditionalImage2" className="input-file-label">
                                                  <Icon>attach_file</Icon>
                                                  <label>
                                                      {this.state.productAdditionalImage2 ? this.state.productAdditionalImage2 : <span className="input-file-placeholder">{t('PRODUCT_IMAGE')} {t('IMAGE_SIZE_MESSAGE')}</span>}
                                                  </label>
                                              </label>
                                          </Grid>
                                          <Grid item size={{ xs: 12, md: 12}}>
                                              <Input
                                                  name={'productAdditionalImage3'}
                                                  onChange={event => onImageChange(event, "productAdditionalImage3Src")}
                                                  inputProps={{ id: "productAdditionalImage3" }}
                                                  // placeholder={'Image'}
                                                  type="file"
                                                  className="custom-file-input"
                                                  source={this.state.productAdditionalImage3Src}
                                                  disabled={this.props.disableInputFields}
                                              />
                                              <label htmlFor="productAdditionalImage3" className="input-file-label">
                                                  <Icon>attach_file</Icon>
                                                  <label>
                                                      {this.state.productAdditionalImage3 ? this.state.productAdditionalImage3 : <span className="input-file-placeholder">{t('PRODUCT_IMAGE')} {t('IMAGE_SIZE_MESSAGE')}</span>}
                                                  </label>
                                              </label>
                                          </Grid>
                                          <Grid item size={{ xs: 12, md: 12}}>
                                              <Input
                                                  name={'productAdditionalImage4'}
                                                  onChange={event => onImageChange(event, "productAdditionalImage4Src")}
                                                  inputProps={{ id: "productAdditionalImage4" }}
                                                  // placeholder={'Image'}
                                                  type="file"
                                                  className="custom-file-input"
                                                  source={this.state.productAdditionalImage4Src}
                                                  disabled={this.props.disableInputFields}
                                              />
                                              <label htmlFor="productAdditionalImage4" className="input-file-label">
                                                  <Icon>attach_file</Icon>
                                                  <label>
                                                      {this.state.productAdditionalImage4 ? this.state.productAdditionalImage4 : <span className="input-file-placeholder">{t('PRODUCT_IMAGE')} {t('IMAGE_SIZE_MESSAGE')}</span>}
                                                  </label>
                                              </label>
                                          </Grid>
                                      </Grid>
                                  </>
                              }
                              {
                                  tabValue === 5 && this.props.packageMode === 'edit' &&
                                  <>
                                      {isMobile &&
                                          <h3>
                                              {t("ADDITIONAL_IMAGES")}
                                          </h3>
                                      }
                                      <Grid container spacing={3} justifyContent='space-evenly' style={{ marginTop: '1rem' }}>
                                          <Grid item size={{ xs: 12, sm: 6, md: 3}} className={imageClass.card}>
                                              <div>
                                                  <img
                                                      width="150"
                                                      height="150"
                                                      border="0"
                                                      src={this.state.productAdditionalImage1Src ? this.state.productAdditionalImage1Src : placeholderImage}
                                                      className={imageClass.cardImage}
                                                      alt=""
                                                  />
                                              </div>
                                              <div className={imageClass.cardDetail}>
                                                  <input
                                                      name={'productAdditionalImage1'}
                                                      accept="image/*"
                                                      id="contained-button-file-1"
                                                      multiple
                                                      type="file"
                                                      source={this.state.productAdditionalImage1Src}
                                                      onChange={event => onImageChange(event, "productAdditionalImage1Src")}
                                                      disabled={this.props.disableInputFields}
                                                  />
                                                  {!this.props.disableInputFields &&
                                                      <label htmlFor="contained-button-file-1" className='button'>
                                                          {t('UPLOAD_FILE')}
                                                      </label>
                                                  }
                                              </div>
                                          </Grid>
                                          <Grid item size={{ xs: 12, sm: 6, md: 3}} className={imageClass.card}>
                                              <div>
                                                  <img
                                                      width="150"
                                                      height="150"
                                                      border="0"
                                                      src={this.state.productAdditionalImage2Src ? this.state.productAdditionalImage2Src : placeholderImage}
                                                      //src={this.props.images[2] ? constants.imageUrl + this.props.images[2] : placeholderImage}
                                                      className={imageClass.cardImage}
                                                      alt=""
                                                  //disabled={this.props.providerType === 'SALES_CHNL_PROVIDER'}
                                                  />
                                              </div>

                                              <div className={imageClass.cardDetail}>
                                                  <input
                                                      name={'productAdditionalImage2'}
                                                      accept="image/*"
                                                      id="contained-button-file-2"
                                                      multiple
                                                      type="file"
                                                      source={this.state.productAdditionalImage2Src}
                                                      onChange={event => onImageChange(event, "productAdditionalImage2Src")}
                                                      disabled={this.props.disableInputFields}
                                                  //disabled={this.props.providerType === 'SALES_CHNL_PROVIDER'}
                                                  />
                                                  {!this.props.disableInputFields &&
                                                      <label htmlFor="contained-button-file-2" className='button'>
                                                          {t('UPLOAD_FILE')}
                                                      </label>
                                                  }
                                              </div>
                                          </Grid>
                                          <Grid item size={{ xs: 12, sm: 6, md: 3}} className={imageClass.card}>
                                              <div>
                                                  <img
                                                      width="150"
                                                      height="150"
                                                      border="0"
                                                      src={this.state.productAdditionalImage3Src ? this.state.productAdditionalImage3Src : placeholderImage}
                                                      className={imageClass.cardImage}
                                                      alt=""
                                                  //disabled={this.props.providerType === 'SALES_CHNL_PROVIDER'}
                                                  />
                                              </div>

                                              <div className={imageClass.cardDetail}>
                                                  <input
                                                      name={'productAdditionalImage3'}
                                                      accept="image/*"
                                                      id="contained-button-file-3"
                                                      multiple
                                                      type="file"
                                                      source={this.state.productAdditionalImage3Src}
                                                      onChange={event => onImageChange(event, "productAdditionalImage3Src")}
                                                      disabled={this.props.disableInputFields}
                                                  //disabled={this.props.providerType === 'SALES_CHNL_PROVIDER'}
                                                  />
                                                  {!this.props.disableInputFields &&
                                                      <label htmlFor="contained-button-file-3" className='button'>
                                                          {t('UPLOAD_FILE')}
                                                      </label>
                                                  }
                                              </div>
                                          </Grid>
                                          <Grid item size={{ xs: 12, sm: 6, md: 3}} className={imageClass.card}>
                                              <div>
                                                  <img
                                                      width="150"
                                                      height="150"
                                                      border="0"
                                                      src={this.state.productAdditionalImage4Src ? this.state.productAdditionalImage4Src : placeholderImage}
                                                      className={imageClass.cardImage}
                                                      alt=""
                                                  //disabled={this.props.providerType === 'SALES_CHNL_PROVIDER'}
                                                  />
                                              </div>

                                              <div className={imageClass.cardDetail}>
                                                  <input
                                                      name={'productAdditionalImage4'}
                                                      accept="image/*"
                                                      id="contained-button-file-4"
                                                      multiple
                                                      type="file"
                                                      source={this.state.productAdditionalImage4Src}
                                                      onChange={event => onImageChange(event, "productAdditionalImage4Src")}
                                                      disabled={this.props.disableInputFields}
                                                  //disabled={this.props.providerType === 'SALES_CHNL_PROVIDER'}
                                                  />
                                                  {!this.props.disableInputFields &&
                                                      <label htmlFor="contained-button-file-4" className='button'>
                                                          {t('UPLOAD_FILE')}
                                                      </label>
                                                  }
                                              </div>
                                          </Grid>
                                      </Grid>
                                  </>
                              }

                              <Grid container spacing={3} justifyContent='center'>
                                  {tabValue === 0 &&
                                      <Grid item size={{ xs: 12}}>
                                          <label style={mandatoryMessage}>
                                              {t('MANDATORY_FIELDS_MESSAGE')}
                                          </label>
                                      </Grid>
                                  }
                                  <Grid item size={{ xs: 12}} className="text-right" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                      <div>
                                          {tabValue !== 0 &&
                                               <Button
                                               className="buttonSecondary"
                                               onClick={() => this.back()}
                                               disabled={this.state.disableButton}
                                             >
                                               {t("BACK")}
                                             </Button>
                                          }
                                      </div>
                                      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem' }}>
                                      <Button
                                        onClick={() => this.props.downloadTemplate()}
                                        disabled={this.state.disableButton}
                                        className={
                                          // classes.downloadTemplateButton +
                                          " " +
                                          "buttonSecondary"
                                        }
                                      >
                                        {t("EXPORT_PRODUCT_TEMPLATE")}
                                      </Button>
                                      {this.props.packageMode == 'edit' && <Button onClick={() => this.props.offeringSummary()}
                                          className={
                                            //classes.downloadTemplateButton + 
                                          ' ' + 'buttonSecondary'}>
                                          {t('OFFERING_SUMMARY')}
                                      </Button>}
                                      <Button
                                        onClick={() => this.next(true)}
                                        disabled={this.state.disableButton}
                                      >
                                        {t("NEXT")}
                                      </Button>
                                      </div>
                                  </Grid>
                              </Grid>
                          </Grid>
          </>
      )
  }

    return (
      <div style={{ marginTop: 0 }}>
        {this.props.packageMode !== "promo" && (
          <>
            <Grid container spacing={0}>
              {!isMobile ? (
                !showBucketsOnLeft ? (
                  this.props.packageMode !== "promo" && (
                    <Grid
                      container
                      spacing={1}
                      style={{ justifyContent: "center", marginTop: "1rem" }}
                    >
                      <Grid
                        item
                        style={{ paddingTop: 0 }}
                        size={{
                          xs: 12,
                        }}
                      >
                        <Box
                          display="flex"
                          justifyContent="center"
                          width="100%"
                        >
                          <Tabs
                            // indicatorColor="primary"
                            onChange={this.handleChange}
                            // textColor="primary"
                            value={tabValue}
                            variant="scrollable"
                            className={tab.createPackageTabs}
                          // className={['normalizeTabText', tab.createPackageTabs].join(' ')}
                          >
                            <Tab value={0} label={t("BASIC_DETAILS")} />
                            {/* <Tab value={1} label={t('CUSTOM_ATTRIBUTES')} /> */}
                            {this.props.showCustomAttributes && (
                              <Tab value={1} label={t("CUSTOM_ATTRIBUTES")} />
                            )}
                            <Tab value={2} label={t("OVERVIEW")} />
                            <Tab value={3} label={t("TECH_SPECS")} />
                            <Tab value={4} label={t("WHAT_IS_INCLUDED")} />
                            <Tab value={5} label={t("ADDITIONAL_IMAGES")} />
                          </Tabs>
                        </Box>
                      </Grid>
                      <Box
                        className={tab.tabUnderLine}
                        style={{
                          display: "flex",
                          marginTop: "2rem",
                          marginBottom: "1rem",
                          justifyContent: "center",
                          width: "100%",
                        }}
                      ></Box>
                      {basicDetailsTab()}
                    </Grid>
                  )
                ) : (
                  <Split
                    sizes={[20, 80]} // Initial sizes in percentages
                    minSize={[200, 700]} // Minimum sizes in pixels
                    expandToMin={false}
                    gutterSize={10}
                    gutterAlign="center"
                    snapOffset={30}
                    dragInterval={1}
                    direction="horizontal"
                    cursor="col-resize"
                    className="split"
                  >
                    {/* left */}
                    <div style={{ overflow: "auto", borderRight: "1px solid lightgrey" }}>
                  <Grid item size={{ xs: 12, md: 12}} style={{ padding: '1rem' }}>
                    {/* tabs */}
                    <List disablePadding>
                      {tabs.map((tab, index) => (
                        <ListItemButton
                          key={index}
                          onClick={(e) => this.handleChange(e, tab.value)}
                          sx={(theme) => ({
                            borderRadius: this.state.tabValue === tab.value ? '0px 6px 6px 0px' : '6px',
                            borderLeft: `2px solid ${this.state.tabValue === tab.value ? this.props.tenantData.color : "transparent"
                              }`,
                            fontWeight: this.state.tabValue === tab.value ? "bold" : "normal",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            color: this.state.tabValue === tab.value ? this.props.tenantData.color : "inherit",
                            "&:hover": {
                              backgroundColor: alpha(
                                this.props.tenantData.color || theme.palette.primary.main,
                                0.12
                              ),
                              color: this.props.tenantData.color || theme.palette.primary.main,
                            },
                          })}
                        >
                          <ListItemText primary={tab.text} />
                        </ListItemButton>
                      ))}
                    </List>
                    {/* <List>
                      {[
                        { text: t("BASIC_DETAILS"), value: 0 },
                        { text: t("OVERVIEW"), value: 2 },
                        { text: t("TECH_SPECS"), value: 3 },
                        { text: t("WHAT_IS_INCLUDED"), value: 4 },
                        { text: t("ADDITIONAL_IMAGES"), value: 5 },
                        this.props.showCustomAttributes && {
                          text: t("CUSTOM_ATTRIBUTES"),
                          value: 1,
                        },
                      ]
                        .filter(Boolean)
                        .map((tab, index) => (
                          <React.Fragment key={index}>
                            <ListItem
                              button
                              key={tab.text}
                              className={
                                activeTab === tab.value
                                  ? classes.selected
                                  : classes.listItem
                              }
                              onClick={(e) => {
                                this.handleChange(e, tab.value);
                                this.setState({
                                  activeTab: tab.value,
                                });
                              }}
                              style={
                                {
                                  borderLeft: activeTab === tab.value ? `2px solid ${this.props.tenantData.color}` : `2px solid white`,
                                  fontWeight: activeTab === tab.value ? 'bold' : 'normal',
                                  display: 'flex', justifyContent: 'space-between', alignItems: 'center'
                                }
                              }
                            >
                              <ListItemText
                                style={{ color: activeTab === tab.value ? this.props.tenantData.color : "inherit" }}
                                primary={tab.text}
                              />
                            </ListItem>
                          </React.Fragment>
                        ))}
                    </List> */}
                  </Grid>
                  </div>
                  {/* right */}
                  <div style={{ overflow: 'auto' }}>
                    {basicDetailsTab()}
                  </div>
                  </Split>
                )
              ) : (
                isMobile &&
                showCategory && (
                  <Drawer
                    anchor="left"
                    // variant='permanant'
                    open={showCategory}
                    onClose={() => {
                      this.props.toggleShowCategory();
                    }}
                    // classes={{ paper: classes.drawerPaper }}
                    PaperProps={{
                      style: {
                        width: "100%",
                        maxWidth: "100vw",
                      },
                    }}
                  >
                    <div>
                      <div>
                        <IconButton
                          onClick={() => {
                            this.props.toggleShowCategory();
                          }}
                        >
                          <ChevronLeft />
                        </IconButton>
                      </div>
                      <Card variant="outlined" className={"roundedCorners"}>
                        {stepsList}
                      </Card>
                    </div>
                  </Drawer>
                )
              )}
               {(isMobile && !showCategory) && basicDetailsTab()}
            </Grid>

            {/* coment the old grid */}
            {/* <Grid container spacing={3} justifyContent="center" >
                        <Grid item xs={12} >
                            <Tabs
                                centered
                                indicatorColor="primary"
                                onChange={this.handleChange}
                                // textColor="primary"
                                value={tabValue}
                                // variant="scrollable"
                                className={['normalizeTabText', tab.createPackageTabs].join(' ')}
                            >
                                <Tab value={0} label={t('BASIC_DETAILS')} />
                                {this.props.showCustomAttributes &&
                                    <Tab value={1} label={t('CUSTOM_ATTRIBUTES')} />
                                }
                                <Tab value={2} label={t('OVERVIEW')} />
                                <Tab value={3} label={t('TECH_SPECS')} />
                                <Tab value={4} label={t('WHAT_IS_INCLUDED')} />
                                <Tab value={5} label={t('ADDITIONAL_IMAGES')} />
                            </Tabs>
                        </Grid>
                    </Grid> */}
          </>
        )}
        <Loader loading={this.state.loading} />
      </div>
    );
  }
}
// export default basicDetail
const mapStateToProps = (state) => {
  return {
    providerId: state.auth.tenantId,
    providerType: state.auth.providerType,
    providerName: state.auth.providerName,
    enabledModules: state.auth.enabledModules,
    tenantData: state.auth.tenantData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(BasicDetails));
